import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Card } from '@redlink/components/atoms';

export const DataEntryModalTemplate = memo(
  ({ children, previewContainerStyle }) => {
    const { styles } = useStyle();
    const hasTwoColumn = !!children[1];
    return (
      <View
        style={[
          styles.mainContainer,
          !hasTwoColumn && styles.mainContainerSoloColumn,
        ]}
      >
        <View style={styles.formContainer}>
          {hasTwoColumn ? children[0] : children}
        </View>
        {hasTwoColumn && (
          <>
            <Space />
            <Card style={[styles.previewContainer, previewContainerStyle]}>
              {children[1]}
            </Card>
          </>
        )}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, height }) => ({
  mainContainer: {
    width: 750,
    height: height * 0.8,
    maxHeight: 700,
    borderRadius: 12,
    padding: 2,
    flexDirection: 'row',
  },
  mainContainerSoloColumn: {
    width: 450,
  },
  formContainer: {
    flex: 6,
  },
  previewContainer: {
    width: 340,
    justifyContent: 'center',
    backgroundColor: colors.background,
  },
}));
